import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import VCalendar from 'v-calendar';

import './style/variables.css'
import './assets/mainStyle.css'
// 导入KaTeX CSS样式
import 'katex/dist/katex.min.css';

import naive from 'naive-ui';
import VueCalendarHeatmap from 'vue3-calendar-heatmap'


createApp(App)
  .use(VCalendar,{})
  .use(router)
  .use(naive)
  .use(VueCalendarHeatmap)
  .mount('#app');
